<div class="settings-profile">
    <div class="settings-header">
        <div class="header-wrapper">
            <h2 class="settings-title">Settings</h2>
        </div>
    </div>
    <div class="settings-container">
        <div class="settings-sidebar">
            <div class="sidebar-menu">
                <div class="menu-item" [class.selected]="selectedMenuItem === 'account'"
                     (click)="onMenuItemClick('account')">
                    <inline-svg src="Profile.svg" className="menu-icon"
                                hoverColor="#7F8F98"
                                activeColor="#85BBF3"
                    ></inline-svg>

                    <span class="menu-label">Account</span>
                </div>
                <div class="menu-item" [class.selected]="selectedMenuItem === 'changePassword'"
                     (click)="onMenuItemClick('changePassword')">
                    <inline-svg src="change-password.svg" className="menu-icon"
                                hoverColor="#7F8F98"
                                activeColor="#85BBF3"

                    ></inline-svg>
                    <span class="menu-label">Change Password</span>
                </div>
                <div class="menu-item" [class.selected]="selectedMenuItem === 'team'" (click)="onMenuItemClick('team')">
                    <inline-svg src="team.svg" className="menu-icon"
                                hoverColor="#7F8F98"
                                activeColor="#85BBF3"

                    ></inline-svg>
                    <span class="menu-label">Team</span>
                </div>
                <div class="menu-item" [class.selected]="selectedMenuItem === 'usage'"
                     (click)="onMenuItemClick('usage')">
                    <inline-svg src="Data-Usage.svg" className="menu-icon"
                                hoverColor="#7F8F98"
                                activeColor="#85BBF3"

                    ></inline-svg>
                    <span class="menu-label">Plan & Usage</span>
                </div>
                <div class="menu-item" [class.selected]="selectedMenuItem === 'apiKeys'"
                     (click)="onMenuItemClick('apiKeys')">
                    <inline-svg src="API-key.svg" className="menu-icon"
                                hoverColor="#7F8F98"
                                activeColor="#85BBF3"

                    ></inline-svg>
                    <span class="menu-label">API Keys</span>
                </div>

            </div>
        </div>
        <div class="settings-main">
            <div class="settings-wrapper">
                <router-outlet></router-outlet>
            </div>
<!--            <div class="settings-sidebar"></div>-->
        </div>

    </div>
</div>